"use client";

import { LockedOverlay } from "./LockedOverlay";
import { FakeDataWatermark } from "./FakeDataWatermark";

const HEADERS = ["Rank", "Mentions", "Image", "Name", "Release", "Price", "1D", "7D", "30D"];

const FAKE_ROWS = [
  { rank: 1, mentions: "26,058", name: "Phantom Odyssey", release: "Mar 2025", price: "$29.99", d1: "+142", d7: "+891", d30: "+3,204" },
  { rank: 2, mentions: "25,695", name: "Stellar Vanguard", release: "Jan 2025", price: "$39.99", d1: "+98", d7: "+672", d30: "+2,841" },
  { rank: 3, mentions: "23,430", name: "Crimson Protocol", release: "Apr 2024", price: "$19.99", d1: "+76", d7: "+534", d30: "+1,932" },
  { rank: 4, mentions: "22,300", name: "Neon Abyss Zero", release: "Feb 2025", price: "Free", d1: "+64", d7: "+421", d30: "+1,677" },
  { rank: 5, mentions: "22,020", name: "Ironclad Legacy", release: "Nov 2024", price: "$49.99", d1: "+53", d7: "+387", d30: "+1,502" },
  { rank: 6, mentions: "21,937", name: "Void Breakers", release: "Jul 2024", price: "$24.99", d1: "+41", d7: "+298", d30: "+1,231" },
  { rank: 7, mentions: "21,850", name: "Arctic Siege II", release: "Sep 2024", price: "$34.99", d1: "+38", d7: "+256", d30: "+1,098" },
  { rank: 8, mentions: "21,412", name: "Drift Horizon", release: "Dec 2024", price: "$14.99", d1: "+29", d7: "+201", d30: "+879" },
  { rank: 9, mentions: "20,501", name: "Eclipse Frontier", release: "Oct 2024", price: "$44.99", d1: "+22", d7: "+167", d30: "+732" },
  { rank: 10, mentions: "17,998", name: "Shadow Meridian", release: "Aug 2024", price: "$29.99", d1: "+18", d7: "+134", d30: "+598" },
];

export function LockedMltTable() {
  return (
    <div data-nosnippet className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden relative">
      <div className="select-none blur-[6px] pointer-events-none relative">
        {/* Header */}
        <div className="hidden md:flex items-center gap-2 px-2 py-1.5 h-8 border-b border-[#2a475e] bg-[#1b2838] text-[#c7d5e0] text-[11px] font-semibold uppercase tracking-wide">
          {HEADERS.map((h) => (
            <div
              key={h}
              className={
                h === "Name"
                  ? "flex-1 min-w-0"
                  : h === "Image"
                    ? "w-[100px] flex-shrink-0"
                    : "w-[64px] flex-shrink-0 text-right"
              }
            >
              {h}
            </div>
          ))}
        </div>

        {/* Data rows */}
        {FAKE_ROWS.map((row, i) => (
          <div
            key={row.rank}
            className={`hidden md:flex items-center gap-2 border-b border-[#2a475e] ${
              i % 2 === 1 ? "bg-[#15212f]" : ""
            }`}
          >
            <div className="w-[64px] flex-shrink-0 px-2 text-right font-bold text-[13px] text-[#66c0f4]">
              #{row.rank}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right font-bold text-[13px] text-[#66c0f4]">
              {row.mentions}
            </div>
            <div className="w-[100px] h-[37px] flex-shrink-0 bg-[#2a475e]" />
            <div className="flex-1 min-w-0 px-2 text-white font-medium text-[13px] truncate">
              {row.name}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right text-[#8f98a0] text-[11px]">
              {row.release}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right text-[#c7d5e0] text-xs">
              {row.price}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right text-[#4ade80] text-[13px]">
              {row.d1}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right text-[#4ade80] text-[13px]">
              {row.d7}
            </div>
            <div className="w-[64px] flex-shrink-0 px-2 text-right text-[#4ade80] text-[13px]">
              {row.d30}
            </div>
          </div>
        ))}

        {/* Mobile */}
        <div className="md:hidden divide-y divide-[#2a475e]">
          {FAKE_ROWS.slice(0, 6).map((row) => (
            <div key={row.rank} className="px-3 py-2 space-y-1.5">
              <div className="flex items-center gap-3">
                <div className="w-[100px] h-[37px] flex-shrink-0 bg-[#2a475e]" />
                <div className="flex-1 min-w-0">
                  <span className="text-white font-medium text-[13px] block truncate">{row.name}</span>
                  <span className="text-[#8f98a0] text-[11px]">{row.release}</span>
                </div>
              </div>
              <div className="flex justify-between text-xs text-[#8f98a0]">
                <span>Mentions: <span className="text-[#66c0f4] font-bold">{row.mentions}</span></span>
                <span>{row.price}</span>
              </div>
            </div>
          ))}
        </div>

        <FakeDataWatermark />
      </div>

      <LockedOverlay message="Sign in to see More Like This rankings" surface="topmlt_page" />
    </div>
  );
}
